import { Box, Skeleton, Typography} from "@mui/material";
import CustomAlert from "../../events/components/CustomAlert"
import { useDispatch, useSelector } from "react-redux";
import { updateTeamState } from "../../../redux/teamSlice";
import { updateProjectState } from "../../../redux/projectSlice";
import { useEffect, useRef, useState } from "react";
import RequestLog from "./RequestLog";
import { generateDarkColor } from "../../../utils/commonServices";
import RevisionLogNote from "./RevisionLogNote";
import useRevisionActions from "../useRevisionActions";
// import CustomCard from "../../events/components/CustomCard";
import CustomCard from "../../../components/CustomCard";


const VideoComparePopup = (props) => {
    
   
    const dispatch = useDispatch()
      const projectReducer = useSelector((state) => state.projectReducer);
      const reviewEventReducer = useSelector((state) => state.reviewEventReducer);
      const {getRevisionDetails} = useRevisionActions()
      const videoRefs = useRef({}); // A ref object to manage video elements by id
      const commonReducer = useSelector((state) => state.root.commonReducer);
      const selectedVideos = projectReducer.selectedVideos 

    const handleClose = () => {
      dispatch(updateProjectState({compare_videos_popup : false}))      
    };

    const videoOneId = reviewEventReducer?.selected_video_ids[0]
    const videoTwoId = reviewEventReducer?.selected_video_ids[1]
    // const videoOne = reviewEventReducer?.internal_revisions_list?.find(item => item.id === videoOneId)
    // const videoTwo = reviewEventReducer?.internal_revisions_list?.find(item => item.id === videoTwoId)
    const [videoOneDetails, setVideoOneDetails] = useState({})
    const [videoTwoDetails, setVideoTwoDetails] = useState({})

    useEffect(()=>{
        getRevisionDetails({id:videoOneId}, setVideoOneDetails)
        getRevisionDetails({id:videoTwoId}, setVideoTwoDetails)
    },[])

    const parseTimestampToSeconds = (timestamp) => {
      const [minutes, seconds] = timestamp.split(":").map(Number);
      return minutes * 60 + seconds;
    };
  

    const handleSeek = (videoId, timestamp) => {
      const videoElement = videoRefs.current[videoId];
      if (videoElement) {
        const seconds = parseTimestampToSeconds(timestamp);
        videoElement.currentTime = seconds; 
        // videoElement.play(); 
      }
    };


  

    return (
        <CustomAlert 
          open={projectReducer.compare_videos_popup} 
          handleClose={handleClose} 
          height={{xs:'420px', md:'75%',lg:'94%',xl:'750px'}}
          width={{md:'65%',lg:'75%', xl:'1500px'}}
          large
    
          >       
            <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
          backgroundColor: "#fff",
        }}
        px={4}
        pt={1}
        pb={1}
      >
       
        <Box
          sx={{
            display: "flex",
            // flexGrow: 1,
            height:'100%',
            justifyContent: "space-between",
            alignItems: "start",
            gap: 2,
          }}
          pt={4}
        >
          {reviewEventReducer?.selected_video_ids?.length == 2 && (
            <>
              {/* First Video */}
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  width: "45%",
                //   border: "1px solid #ddd",
                  borderRadius: "8px",
                  overflow: "hidden",
                  height:'100%',
                  // backgroundColor:'red'
                }}
              >
               {reviewEventReducer?.revision_details_loading ?  <Skeleton  sx={{backgroundColor:'whitesmoke', mt: 2, ml:3, mr:3}} animation='pulse' variant="rounded" width='40%' height='20px' /> :<Typography
                  sx={{ textAlign: "center", marginBottom: "8px" }}
                >
                  {`Version ${videoOneDetails?.version}`}
                </Typography>}
                {reviewEventReducer?.revision_details_loading ?  <Skeleton  sx={{backgroundColor:'whitesmoke', mt: 2, ml:3, mr:3}} animation='pulse' variant="rounded"  width="85%" height='40%' /> :  <video
                   controls
                    ref={(ref) => (videoRefs.current[videoOneDetails?.id] = ref)}
                    src={videoOneDetails?.video_url}
                    style={{
                      width: "85%",
                      borderRadius: "8px",
                      backgroundColor: "#000",
                      maxHeight:'43%'
                    }}
                      onContextMenu={(e) => e.preventDefault()}
                     controlsList="nodownload noremoteplayback"
                />}
                <Box sx={{display:'flex', justifyContent:'flex-start', flexDirection:'column', alignItems:'start', width:'100%', border:!reviewEventReducer?.revision_details_loading &&  '1px solid #dddddd', maxHeight:'50%', padding:2, mt:1, overflowY:'scroll', minHeight:'40%'}}>
                  {  reviewEventReducer?.revision_details_loading ? <CustomCard sx={{ width:'100%', height:'100%', borderRadius:'5px', mt:2.5, mr:2, opacity: 0.5, display:'flex', flexDirection:'column', alignItems:'space-evenly'}}>
                              {/* <Skeleton variant="rounded" animation='pulse' height='125px' width='320px'/> */}
                              <Skeleton variant="rounded" animation='pulse' height='15px' width='40%' sx={{mt:2, ml:2}}/>
                              <Skeleton variant="rounded" animation='pulse' height='18px' width='60%' sx={{mt:2, ml:2}}/>
                              <Skeleton variant="rounded" animation='pulse' height='18px' width='90%' sx={{mt:2, ml:2}}/>
                              <Skeleton variant="rounded" animation='pulse' height='18px' width='18px' sx={{ml:2, mt:1}}/>
                            </CustomCard> :  videoOneDetails?.logs?.map((log, index) => (
                       <Box mt={1} onClick={() => handleSeek(videoOneDetails?.id, log.timestamp)} sx={{display:'flex',  width:'100%', justifyContent:log.username == commonReducer?.user_name ? 'end': 'start'}}>
                         <RevisionLogNote popup={true} color={generateDarkColor(log, 'username')} userName={log.username} message = {log.message} timestamp={log.timestamp}/>
                       </Box>
   
                  ))}
                </Box>
                      
                   
              </Box>

              {/* Divider */}
              <Box
                sx={{
                  width: "1px",
                  backgroundColor: "#ddd",
                  height: "90%",
                  alignSelf: "center",
                }}
              />


              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  width: "45%",
                  borderRadius: "8px",
                  overflow: "hidden",
                  height:'100%'
                }}
              >
              {reviewEventReducer?.revision_details_loading ?  <Skeleton  sx={{backgroundColor:'whitesmoke', mt: 2, ml:3, mr:3}} animation='pulse' variant="rounded" width='40%' height='20px' /> :  <Typography
                  sx={{ textAlign: "center", marginBottom: "8px" }}
                >
                  {`Version ${videoTwoDetails?.version}`}
                </Typography>}

               {reviewEventReducer?.revision_details_loading ?  <Skeleton  sx={{backgroundColor:'whitesmoke', mt: 2, ml:3, mr:3}} animation='pulse' variant="rounded"  width="85%" height='40%' /> :  <video
                   controls
                   ref={(ref) => (videoRefs.current[videoTwoDetails?.id] = ref)}
                    src={videoTwoDetails?.video_url}
                    style={{
                      width: "85%",
                      borderRadius: "8px",
                      backgroundColor: "#000",
                      maxHeight:'43%'
                    }}
                    onContextMenu={(e) => e.preventDefault()}
                     controlsList="nodownload noremoteplayback"
                />}
                   <Box sx={{display:'flex', justifyContent:'flex-start', flexDirection:'column', alignItems:'start', width:'100%', border:!reviewEventReducer?.revision_details_loading && '1px solid #dddddd', maxHeight:'50%', padding:2, mt:1, overflowY:'scroll', minHeight:{xs:'30%',lg:'40%',xl:'40%'}}}>
                  {reviewEventReducer?.revision_details_loading ? <CustomCard sx={{width:'100%', height:'100%', borderRadius:'5px', mt:2.5, mr:2, opacity: 0.5, display:'flex', flexDirection:'column', alignItems:'space-evenly'}}>
                              {/* <Skeleton variant="rounded" animation='pulse' height='125px' width='320px'/> */}
                              <Skeleton variant="rounded" animation='pulse' height='15px' width='80%' sx={{mt:2, ml:2}}/>
                              <Skeleton variant="rounded" animation='pulse' height='18px' width='60%' sx={{mt:2, ml:20, mr:0}}/>
                              <Skeleton variant="rounded" animation='pulse' height='18px' width='60%' sx={{mt:2, ml:2}}/>
                             
                            </CustomCard> :  videoTwoDetails?.logs?.map((log, index) => (  
                    
                       <Box mt={1} onClick={() => handleSeek(videoTwoDetails?.id, log.timestamp)} sx={{display:'flex',  width:'100%', justifyContent:log.username == commonReducer?.user_name ? 'end': 'start'}}>
                         <RevisionLogNote popup={true} color={generateDarkColor(log, 'username')} userName={log.username} message = {log.message} timestamp={log.timestamp}/>
                       </Box>
                  ))}
                </Box>
              </Box>
            </>
          ) }
        </Box>
      </Box>
          
       
        </CustomAlert>
      )
}

export default VideoComparePopup
